module.exports = __webpack_public_path__ + "static/img/twdx.57b2a9f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/fiveG/function/twdx.gif
// module id = FxiI
// module chunks = 1